/* eslint-disable react-hooks/exhaustive-deps */
import { Cancel, Delete, Save } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogContent,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import { ImagePicker } from "components";
import React, { useEffect, useState } from "react";
import { useForm } from "hooks"
import { Group } from "../GroupsPanel";
import DialogHeader from "./DialogHeader";
import { useBreakpoint, useTranslations } from "hooks";
import { getTranslation } from "common";
import { Validation, isRequired } from "hooks/useForm";
import ResourceUsersEditor from "components/ResourceUsersEditor";
import FlowentiButton from "components/flowenti-ui-kit/FlowentiButton";

interface GroupDialogProps {
  open: boolean;
  group: Group | null;
  organizationId?: number | null;
  onClose: () => void;
  onDelete?: () => void;
  onSave: (photo: string | null, name: string | null) => Promise<void>;
  onUsersUpdate?: () => void;
  loading: boolean;
}

const GroupDialog: React.FC<GroupDialogProps> = ({
  open,
  group,
  organizationId,
  onClose,
  onSave,
  onDelete,
  onUsersUpdate,
  loading,
}) => {
  const translations = useTranslations();
  const [saveLoading, setSaveLoading] = useState<boolean>(false)
  const validations: Validation[] = [
    ({ name }) =>
      isRequired(name) || {
        name: getTranslation(translations, "placeholders.nameisrequired.label"),
      },
  ]

  const isMobile = useBreakpoint("down", "sm")
  const {
    reset,
    isValid,
    changeHandler,
    values,
    errors,
    touched,
    setValues,
  } = useForm({
    name: group?.name || "",
    icon: group?.icon || "",
  },
    validations
  );
  useEffect(() => {
    if (!open) {
      reset();
    }
  }, [open]);

  useEffect(() => {
    setValues(group)
  }, [group]);


  return (
    <Dialog fullScreen={isMobile} open={open} onClose={() => onClose()}>
      <DialogHeader onClose={onClose}>
        {getTranslation(translations, "groups.edit.suggestnew")}
      </DialogHeader>
      <DialogContent>
        <Stack direction="row" sx={{ pt: (_) => _.spacing(0.7) }} spacing={2}>
          <Box flex={1}>
            <ImagePicker
              photoUrl={values?.icon || ""}
              relativePath={group?.icon || ""}
              setPhotoUrl={(value) => changeHandler("icon", value)}
            />
          </Box>
          <Grid component="form" flex={2} container>
            <Grid item xs={12}>
              <TextField
                id="groups-dialog"
                variant="outlined"
                fullWidth
                size="small"
                label={getTranslation(translations, "placeholders.group.name.label")}
                error={Boolean(touched.name && errors.name)}
                helperText={touched.name && errors.name}
                value={values?.name || ""}
                onChange={({ target }) => changeHandler("name", target.value)}
              />
            </Grid>
            <Grid
              item
              display="flex"
              justifyContent="flex-end"
              alignItems="flex-end"
              xs={12}
            >
              <Stack
                direction="row"
                justifyContent="flex-end"
                alignItems="flex-end"
                spacing={2}
              >
                {onDelete && (
                  <FlowentiButton
                    id="btn-cancel-group"
                    variant="contained"
                    // color="error"
                    startIcon={<Delete />}
                    size="small"
                    onClick={() => onDelete()}
                  >
                    {getTranslation(translations, "user.buttondelete.label")}
                  </FlowentiButton>
                )}
                <FlowentiButton
                  variant="contained"
                  // color="warning"
                  startIcon={<Cancel />}
                  size="small"
                  onClick={() => onClose()}
                >
                  {getTranslation(translations, "user.buttoncancel.label")}
                </FlowentiButton>
                <FlowentiButton
                  id="btn-save-group"
                  variant="contained"
                  disabled={!isValid || saveLoading || loading}
                  startIcon={<Save />}
                  type="submit"
                  size="small"
                  onClick={async (e) => {
                    e.preventDefault();
                    setSaveLoading(true);
                    await onSave(values.icon, values.name);
                    setSaveLoading(false);
                  }}
                >
                  {getTranslation(translations, "pm.button.save")}
                </FlowentiButton>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
        <ResourceUsersEditor
          resource="groups"
          resourceId={group?.id}
          organizationId={organizationId}
          disabled={loading}
          onUpdate={onUsersUpdate}
        />
      </DialogContent>
    </Dialog>
  );
};

export default GroupDialog;
